module.exports = __webpack_public_path__ + "img/tas_no.1c63d16b.png";